export default __webpack_public_path__ + "static/facilitators-298a18c04f0bdb8cb72e9ee7b488a42f.webp";